module.exports = __webpack_public_path__ + "img/logout-mobile.325f65f1.svg";